module.exports = __webpack_public_path__ + "static/media/trust.97e1d6c8.jpg";